var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetpassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0.953125C14.1817 0.953125 0.953125 14.1817 0.953125 30.5C0.953125 46.8183 14.1817 60.0469 30.5 60.0469C46.8183 60.0469 60.0469 46.8183 60.0469 30.5C60.0469 14.1817 46.8183 0.953125 30.5 0.953125ZM30.5 6.67188C43.6688 6.67188 54.3281 17.3291 54.3281 30.5C54.3281 43.6688 43.6709 54.3281 30.5 54.3281C17.3311 54.3281 6.67188 43.6709 6.67188 30.5C6.67188 17.3311 17.3291 6.67188 30.5 6.67188ZM47.204 22.192L44.519 19.4853C43.963 18.9248 43.0578 18.9211 42.4972 19.4772L25.6565 36.1826L18.5328 29.0012C17.9768 28.4407 17.0715 28.437 16.511 28.993L13.8042 31.6779C13.2437 32.234 13.24 33.1392 13.7961 33.6999L24.6118 44.6032C25.1679 45.1637 26.0731 45.1674 26.6336 44.6113L47.196 24.2139C47.7564 23.6578 47.76 22.7525 47.204 22.192Z",
    fill: "#ED1C24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpassword);
export default __webpack_public_path__ + "static/media/resetpassword.bddb401f.svg";
export { ForwardRef as ReactComponent };